<template>
  <el-dialog custom-class="max-dialog" title="录入批次号" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <div class="search-content">
      <el-table
        :data="scancodes"
        size="mini"
        stripe
        border :height="tableHeight(90)"
        style="width: 100%;">
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          label="序号"
          width="50">
        </el-table-column>
        <el-table-column
          prop="seedcode" v-if="false"
          label="编码"
          align="left" width="80" :show-overflow-tooltip="true"
          header-align="center">
          <template slot-scope="scope">
            {{scope.row.seedcode}}
          </template>
        </el-table-column>
        <el-table-column
          prop="seedname"
          label="名称"
          align="left"  width="140" :show-overflow-tooltip="true"
          header-align="center">
        </el-table-column>
        <el-table-column
          prop="packagesize"
          label="度数"
          align="left" width="160"
          header-align="center">
          <template slot-scope="scope">
            {{getPackagesize(scope.row.packagesize)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="totalnumber"
          label="数量"
          align="center"
          width="50"
          header-align="center">
          <template slot-scope="scope">
           1
          </template>
        </el-table-column>
        <el-table-column
          prop="batchno"
          label="批次号"
          align="center"
          width="160"
          header-align="center">
          <template slot-scope="scope">
            <el-input style="width: 85%" size="small" v-model="scope.row.batchno"></el-input>
            <i class="el-icon-bottom" style="cursor: pointer" @click="copyItem(scope.row)"></i>
          </template>
        </el-table-column>
        <el-table-column
          prop="starttime"
          label="生产日期"
          align="center"
          width="150"
          header-align="center">
          <template slot-scope="scope">
            <el-date-picker style="width:100%" size="small"
                            v-model="scope.row.starttime" :value-format="'yyyy-MM-dd'"
                            type="date">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="endtime"
          label="有效期"
          align="center"
          width="150"
          header-align="center">
          <template slot-scope="scope">
            <el-date-picker style="width:100%" size="small"
                            v-model="scope.row.endtime" :value-format="'yyyy-MM-dd'"
                            type="date">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="certno"
          label="证号"
          align="center"
          width="180"
          header-align="center">
          <template slot-scope="scope">
            <el-select v-model="scope.row.certno" @change="selCertNo(scope.row)" filterable size="small">
              <el-option v-for="item in certs" :key="item.unitguid"
                         :label="item.certno"
                         :value="item.certno">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="certorg"
          label="厂家"
          align="center"
          width="140" :show-overflow-tooltip="true"
          header-align="center">
          <template slot-scope="scope">
            {{scope.row.certorg}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogFormVisible=false">取 消</el-button>
      <el-button type="primary" @click="saveData" v-if="isshowqr">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {getlistSimp} from '@/api/set/certmanage'
  import {listData,getDetail} from '@/api/set/jxcstoregoodsbarcode';

  export default {
    name: "ScanCodeBatch",
    data() {
      return {
        isshowqr:false,
        issale:false,
        scancodes: [],
        certs:[],
        dialogFormVisible: false,
      }
    },
    methods: {
      getBarCode(item) {
        getDetail({storegoodsbarcode: item.goodsbarcode}).then(response => {
          if (response.data.code == 0&&response.data.obj) {
            var arr = response.data.obj;
            if (item.seedcode != arr.seedcode) {
              item.goodsbarcode = "";
              this.error('产品编码错误！', item.id)
              return
            }
            if (item.packagesize != arr.packagesize) {
              item.goodsbarcode = "";
              this.error('度数错误！', item.id)
              return
            }

            item.batchno = arr.batchno;
            item.starttime = arr.starttime;
            item.endtime = arr.endtime;
            item.certno = arr.certno;
            item.certorg = arr.certorg;
          }
        });
      },
      getPackagesize(Packagesize) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);
        var rl = '';
        if (ps.type)
          rl = ps.type + '，';

        return rl + 'S：' + ps.Y + ' ， C：' + ps.X;
      },
      error(msg,id) {
        this.$message({
          message: msg,
          type: 'error'
        })
        this.$refs[Object.keys(this.$refs)[id]].focus();
      },
      saveData() {
        //判断唯一码是否唯一
        if (this.scancodes.length > 0) {
          var scancodelist = JSON.parse(JSON.stringify(this.scancodes))
          for (let i in scancodelist) {
            // if(scancodelist[i].goodsbarcode=='') {
            //   if (this.issale) {//销售单允许分批发货
            //
            //   } else {
            //     this.error('唯一码必填', scancodelist[i].id)
            //     return
            //   }
            // }else {
              if (scancodelist[i].batchno == '') {
                this.error('批次号必填', scancodelist[i].id)
                return
              }
              scancodelist[i].goodsbarcode=scancodelist[i].batchno;

              if (scancodelist[i].starttime == '') {
                this.error('生产日期必填', scancodelist[i].id)
                return
              }
              if (scancodelist[i].endtime == '') {
                this.error('有效期必填', scancodelist[i].id)
                return
              }
              if (scancodelist[i].certno == '') {
                this.error('证号必填', scancodelist[i].id)
                return
              }
            //   for (let j in this.scancodes) {
            //     if (scancodelist[i].id != this.scancodes[j].id && scancodelist[i].goodsbarcode == this.scancodes[j].goodsbarcode) {
            //       this.error('唯一码重复' + scancodelist[i].goodsbarcode, scancodelist[i].id)
            //       return
            //     }
            //   }
            // }
          }
        }
        this.dialogFormVisible = false
        this.$emit("scancodeedit", this.scancodes)
      },
      copyItem(item){
        for(let i in this.scancodes){
          if(this.scancodes[i].id>item.id) {
            this.scancodes[i].certorg = item.certorg;
            this.scancodes[i].batchno = item.batchno;
            this.scancodes[i].starttime = item.starttime;
            this.scancodes[i].endtime = item.endtime;
            this.scancodes[i].certno = item.certno;
          }
        }
      },
      selCertNo(item){
        for(let i in this.certs){
          if(this.certs[i].certno==item.certno) {
            item.certorg = this.certs[i].certorg;
          }
        }
      },
      show(controlData,scan,isshowqr) {
        this.issale=controlData.issale;
        console.log(controlData)
        console.log(scan)

        this.isshowqr = isshowqr;
        this.dialogFormVisible = true
        if (!isshowqr) {
          listData({inordernum:controlData.erpserial}).then(response => {
            this.scancodes = response.data.obj
          });
          return;
        }

        var scancodes = JSON.parse(JSON.stringify(scan))

        getlistSimp({
          certtype: '1',
          seedcode: controlData.billmap[0]["seedcode"],
        }).then(response => {
          this.certs = response.data.obj
          if (scancodes.length == 0) {
            var index = 0;
            for (let i in controlData.billmap) {
              for (var j = 0; j < controlData.billmap[i]['数量']; j++) {
                if (controlData.billmap[i]["产品名称"] == "合计")
                  continue;
                scancodes.push({
                  "seedcode": controlData.billmap[i]["seedcode"],
                  "seedname": controlData.billmap[i]["产品名称"],
                  "cangkucode": controlData.cangkucode,
                  "erpserial": controlData.erpserial,
                  "packagesize": controlData.billmap[i]["packagesize"],
                  "totalnumber": 1,
                  "goodsbarcode": "",
                  "batchno": "",
                  "certno": this.certs.length > 0 ? this.certs[0]["certno"] : "",
                  "certorg": this.certs.length > 0 ? this.certs[0]["certorg"] : "",
                  "starttime": "",
                  "endtime": "",
                  "id": index
                });
                index = index + 1;
              }
            }
          }
          this.scancodes = scancodes;

        }).catch((error) => {
          console.log(error)
        });
      },
      //回车跳入下一行  上下方向键
      validateCounts(row, index, e) {
        setTimeout(() => {
          var keyCode = e.keyCode || e.which || e.charCode;
          if (keyCode == 40 || keyCode === 13) {//回车，下方向键
              this.$refs[row.id].blur()
              if (this.scancodes.length - 1 === index) {
                index = -1
              }
              this.$refs[Object.keys(this.$refs)[index + 1]].focus();
          } else if (keyCode == 38) {//上方向键
            this.$refs[row.id].blur()
            if (index === 0) {
              index = this.scancodes.length
            }
            this.$refs[Object.keys(this.$refs)[index - 1]].focus();
          }
        }, 100)
      },
      //给scancodes 添加 id，共回车使用
      indexMethod(index) {
        this.scancodes[index].id = index
        return index + 1;
      }
    },
    mounted() {
    }
    ,
    components: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/ScanCodeBatch.vue